import type { FC } from "react";
import React, { memo, useState } from "react";
import type { TyreType } from "../../../../../../../../common-deprecated/types/CommonTypes";
import { getTyreLabelsUrl } from "../../../../../../../../common-deprecated/settings/utils/commonSettingUtils";
import table from "../../../../../../shared-components/css-modules/toyota/molecules/Table.module.scss";
import Button from "../../../../../../shared-components/css-modules/toyota/atoms/Button";
import styles from "./TyreDetails.module.scss";
import { useCarConfigSelector } from "../../../../../redux/store";
import { getCarConfigLabel, useCarConfigLabel } from "../../../../../utils/labelUtils";

const TyreDetails: FC<{ tyre: TyreType }> = ({ tyre }) => {
    const commonSettings = useCarConfigSelector((state) => state.commonSettings);
    const carConfigSettings = useCarConfigSelector((state) => state.carConfigSettings);
    const eprelAltTag = useCarConfigLabel("carConfigA11yImageEprel", { eprel: tyre.eprelValue });
    /* If the tyre.eprelValue is empty, set the eprelValueError to true
     -> This will show the fallback immediately on page load (gets rid of some Crownpeak errors)*/
    const [eprelValueError, setEprelValueError] = useState<boolean>(!tyre.eprelValue);

    return (
        <div className={styles.grid}>
            <div>
                <table className={table.wrapper}>
                    <tbody>
                        {tyre.tyreLabels.map((label) => {
                            let parsedValue: string;

                            switch (label.value) {
                                case "false":
                                    parsedValue = getCarConfigLabel(
                                        { commonSettings, carConfigSettings },
                                        "carConfigNo",
                                    );
                                    break;
                                case "true":
                                    parsedValue = getCarConfigLabel(
                                        { commonSettings, carConfigSettings },
                                        "carConfigYes",
                                    );
                                    break;
                                default:
                                    parsedValue = label.value;
                            }

                            return (
                                <tr key={label.id}>
                                    <th className={styles.th}>{label.label}</th>
                                    <td className={styles.td}>{parsedValue}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
            <aside>
                {!eprelValueError ? (
                    <img
                        src={getTyreLabelsUrl(commonSettings, tyre.eprelValue)}
                        alt={eprelAltTag}
                        loading="lazy"
                        onError={() => setEprelValueError(true)}
                    />
                ) : (
                    <>
                        {getCarConfigLabel({ commonSettings, carConfigSettings }, "tyreInfoFallbackDescription")}
                        {commonSettings.tyreLabelFallbackService && (
                            <Button
                                variant="btn-text"
                                href={`${commonSettings.tyreLabelFallbackService}${tyre.eprelValue}`}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {getCarConfigLabel({ commonSettings, carConfigSettings }, "tyreInfoFallback")}
                            </Button>
                        )}
                    </>
                )}
            </aside>
        </div>
    );
};

export default memo(TyreDetails);
